import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player/lazy'

import './index.css'

enum PlaybackSettings {
  MutedWithAutoPlayOff = 'Muted with auto play off',
  MutedWithAutoPlayOn = 'Muted with auto play on',
  SoundOnWithAutoPlayOff = 'Sound on with auto play off'
}
interface VideoPlayerProps {
  videoSrc: any
  videoLoop: boolean
  playbackSettings: 'string'
  imageSrc: any
}

const VideoPlayer = ({ videoSrc, imageSrc, videoLoop, playbackSettings }: VideoPlayerProps) => {
  // const [_playerReady, _setPlayerReady] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [mouseIn, setMouseIn] = useState(false)
  const [hover, setHover] = useState(false)
  const [videoMuted, setVideoMuted] = useState(true)
  const [volHover, setVolHover] = useState(false)
  const [lightMode, setLightMode] = useState(
    'https://cdn.differentdog.com/images/unsafe/quality:80/width:572/format:png/plain/https://cdn.builder.io/api/v1/image/assets%2F0e0b081978d0442ca5f36e71c7712df5%2F947b85d1a8db45ac8054600fd9237707'
  )

  useEffect(() => {
    if (imageSrc) setLightMode(imageSrc)
  }, [imageSrc])

  const getPlaybackSettings = () => {
    let settings
    switch (playbackSettings) {
      case PlaybackSettings.MutedWithAutoPlayOn.toString(): {
        settings = {
          playing: true,
          muted: true
        }
        break
      }
      case PlaybackSettings.SoundOnWithAutoPlayOff.toString(): {
        settings = {
          playing: false,
          muted: false
        }
        break
      }
      default: {
        settings = {
          playing: false,
          muted: true
        }
        break
      }
    }
    return settings
  }

  useEffect(() => {
    const videoSetting = getPlaybackSettings()
    if (playbackSettings) {
      setPlaying(videoSetting?.playing)
      setVideoMuted(videoSetting?.muted)
    }
  }, [playbackSettings])

  const play = (e: any) => {
    e.stopPropagation()
    setPlaying(!playing)
    setLightMode('')
  }

  const handleMouseEnter = () => {
    console.log('mouse enter')
    setMouseIn(true)
  }

  const handleMouseLeave = () => {
    console.log('mouse leave')
    setMouseIn(false)
  }

  const handleTouchStart = () => {
    setMouseIn(true)
  }

  const handleButtonEnter = () => {
    setHover(true)
  }

  const handleButtonLeave = () => {
    setHover(false)
  }

  const handleButtonTouchStart = () => {
    setHover(true)
  }

  const handleTouchEnd = () => {
    setTimeout(() => {
      console.log('touch end after 500 ms')
      setMouseIn(false)
    }, 500)
  }

  const mute = (e: any) => {
    e.stopPropagation()
    setVideoMuted(!videoMuted)
  }
  const handleVolumeBtnEnter = () => {
    setVolHover(true)
  }
  const handleVolumeBtnLeave = () => {
    setVolHover(false)
  }
  const handleVolumeBtnTouchStart = () => {
    setVolHover(true)
  }

  const renderPlayButton = () => {
    // if (!playerReady || playing) {
    if (playing) {
      return null
    }

    return (
      <div
        className="video-player-button-wrapper"
        onClick={play}
        onMouseEnter={handleButtonEnter}
        onMouseLeave={handleButtonLeave}
        onTouchStart={handleButtonTouchStart}
      >
        <svg width="100%" height="100%" viewBox="0 0 139 139" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1_2)">
            <circle cx="69.5" cy="69.5" r="69.5" fill="#F9F5F1" />
            {hover && (
              <path
                d="M53 98.6329V39.367C53 34.5437 58.4028 31.6919 62.3851 34.4132L105.75 64.0461C109.237 66.4286 109.237 71.5714 105.75 73.9539L62.3851 103.587C58.4028 106.308 53 103.456 53 98.6329Z"
                fill="#004355"
              />
            )}
            {hover && (
              <path
                d="M48 98.6329V39.367C48 34.5437 53.4028 31.6919 57.3851 34.4132L100.75 64.0461C104.237 66.4286 104.237 71.5714 100.75 73.9539L57.3851 103.587C53.4028 106.308 48 103.456 48 98.6329Z"
                fill="#006685"
              />
            )}
            <path
              d="M48 98.6329V39.367C48 34.5437 53.4028 31.6919 57.3851 34.4132L100.75 64.0461C104.237 66.4286 104.237 71.5714 100.75 73.9539L57.3851 103.587C53.4028 106.308 48 103.456 48 98.6329Z"
              fill="#006685"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_2">
              <rect width="100%" height="100%" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    )
  }

  const renderPauseButton = () => {
    console.log(mouseIn, playing)

    if (mouseIn && playing) {
      return (
        <div
          className="video-player-button-wrapper pause"
          onClick={play}
          onMouseEnter={handleButtonEnter}
          onMouseLeave={handleButtonLeave}
          onTouchStart={handleButtonTouchStart}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 139 139" fill="none">
            <g clipPath="url(#clip0_5_6)">
              <circle cx="69.5" cy="69.5" r="69.5" fill="#F9F5F1" />
              {hover && <rect x="42" y="28.2923" width="22" height="82" rx="6" fill="#004355" />}
              {hover && <rect x="82.7047" y="28" width="22" height="82" rx="6" fill="#004355" />}
              {hover && <rect x="39" y="28.2923" width="22" height="82" rx="6" fill="#006685" />}
              {hover && <rect x="79.7047" y="28" width="22" height="82" rx="6" fill="#006685" />}
              <rect x="39" y="28.2923" width="22" height="82" rx="6" fill="#006685" />
              <rect x="79.7047" y="28" width="22" height="82" rx="6" fill="#006685" />
            </g>
            <defs>
              <clipPath id="clip0_5_6">
                <rect width="100%" height="100%" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      )
    }
    return null
  }

  const renderVolumeOnButton = () => {
    if (!videoMuted) {
      return (
        <div
          className="absolute bottom-8 left-4 z-10"
          onClick={mute}
          onMouseEnter={handleVolumeBtnEnter}
          onMouseLeave={handleVolumeBtnLeave}
          onTouchStart={handleVolumeBtnTouchStart}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 139 139" fill="none">
            <g clipPath="url(#clip0_19_2)">
              <circle cx="69.5" cy="69.5" r="69.5" fill="#F9F5F1" />
              {volHover && (
                <path
                  d="M45.5501 53.875H30C26.6863 53.875 24 56.5613 24 59.875V80.125C24 83.4387 26.6863 86.125 30 86.125H45.5501L62.25 102.786C66.0318 106.559 72.4877 103.881 72.4877 98.5385V41.4615C72.4877 36.1194 66.0318 33.4409 62.25 37.2139L45.5501 53.875ZM110.326 100.224C108.473 102.522 105.064 102.5 102.974 100.415C100.869 98.3148 100.91 94.9219 102.7 92.5471C104.585 90.0449 106.154 87.3114 107.364 84.4079C109.268 79.8418 110.248 74.9453 110.248 70C110.248 65.0547 109.268 60.1582 107.364 55.5921C106.154 52.6886 104.585 49.9551 102.7 47.4529C100.91 45.0781 100.869 41.6852 102.974 39.5849C105.064 37.4998 108.473 37.4782 110.326 39.7762C113.188 43.3247 115.537 47.2669 117.296 51.4888C119.741 57.3554 121 63.6464 121 70C121 76.3536 119.741 82.6446 117.296 88.5112C115.537 92.7331 113.188 96.6753 110.326 100.224ZM94.9833 84.8917C93.3245 87.3635 89.8597 87.3316 87.7523 85.2291C85.6309 83.1126 85.737 79.6895 87.0384 76.9903C88.0803 74.8295 88.6361 72.4433 88.6361 70C88.6361 67.5567 88.0803 65.1705 87.0384 63.0097C85.737 60.3105 85.6309 56.8874 87.7523 54.7709C89.8597 52.6685 93.3245 52.6365 94.9833 55.1083C95.95 56.5489 96.7766 58.0833 97.4491 59.691C98.8152 62.9571 99.5187 66.461 99.5187 70C99.5187 73.539 98.8152 77.0429 97.4491 80.309C96.7766 81.9167 95.95 83.4511 94.9833 84.8917Z"
                  fill="#004355"
                />
              )}
              {volHover && (
                <path
                  d="M42.5501 53.875H27C23.6863 53.875 21 56.5613 21 59.875V80.125C21 83.4387 23.6863 86.125 27 86.125H42.5501L59.25 102.786C63.0318 106.559 69.4877 103.881 69.4877 98.5385V41.4615C69.4877 36.1194 63.0318 33.4409 59.25 37.2139L42.5501 53.875ZM107.326 100.224C105.473 102.522 102.064 102.5 99.9738 100.415C97.8685 98.3148 97.9097 94.9219 99.6995 92.5471C101.585 90.0449 103.154 87.3114 104.364 84.4079C106.268 79.8418 107.248 74.9453 107.248 70C107.248 65.0547 106.268 60.1582 104.364 55.5921C103.154 52.6886 101.585 49.9551 99.6995 47.4529C97.9097 45.0781 97.8685 41.6852 99.9738 39.5849C102.064 37.4998 105.473 37.4782 107.326 39.7762C110.188 43.3247 112.537 47.2669 114.296 51.4888C116.741 57.3554 118 63.6464 118 70C118 76.3536 116.741 82.6446 114.296 88.5112C112.537 92.7331 110.188 96.6753 107.326 100.224ZM91.9833 84.8917C90.3245 87.3635 86.8597 87.3316 84.7523 85.2291C82.6309 83.1126 82.737 79.6895 84.0384 76.9903C85.0803 74.8295 85.6361 72.4433 85.6361 70C85.6361 67.5567 85.0803 65.1705 84.0384 63.0097C82.737 60.3105 82.6309 56.8874 84.7523 54.7709C86.8597 52.6685 90.3245 52.6365 91.9833 55.1083C92.95 56.5489 93.7766 58.0833 94.4491 59.691C95.8152 62.9571 96.5187 66.461 96.5187 70C96.5187 73.539 95.8152 77.0429 94.4491 80.309C93.7766 81.9167 92.95 83.4511 91.9833 84.8917Z"
                  fill="#006685"
                />
              )}
              <path
                d="M42.5501 53.875H27C23.6863 53.875 21 56.5613 21 59.875V80.125C21 83.4387 23.6863 86.125 27 86.125H42.5501L59.25 102.786C63.0318 106.559 69.4877 103.881 69.4877 98.5385V41.4615C69.4877 36.1194 63.0318 33.4409 59.25 37.2139L42.5501 53.875ZM107.326 100.224C105.473 102.522 102.064 102.5 99.9738 100.415C97.8685 98.3148 97.9097 94.9219 99.6995 92.5471C101.585 90.0449 103.154 87.3114 104.364 84.4079C106.268 79.8418 107.248 74.9453 107.248 70C107.248 65.0547 106.268 60.1582 104.364 55.5921C103.154 52.6886 101.585 49.9551 99.6995 47.4529C97.9097 45.0781 97.8685 41.6852 99.9738 39.5849C102.064 37.4998 105.473 37.4782 107.326 39.7762C110.188 43.3247 112.537 47.2669 114.296 51.4888C116.741 57.3554 118 63.6464 118 70C118 76.3536 116.741 82.6446 114.296 88.5112C112.537 92.7331 110.188 96.6753 107.326 100.224ZM91.9833 84.8917C90.3245 87.3635 86.8597 87.3316 84.7523 85.2291C82.6309 83.1126 82.737 79.6895 84.0384 76.9903C85.0803 74.8295 85.6361 72.4433 85.6361 70C85.6361 67.5567 85.0803 65.1705 84.0384 63.0097C82.737 60.3105 82.6309 56.8874 84.7523 54.7709C86.8597 52.6685 90.3245 52.6365 91.9833 55.1083C92.95 56.5489 93.7766 58.0833 94.4491 59.691C95.8152 62.9571 96.5187 66.461 96.5187 70C96.5187 73.539 95.8152 77.0429 94.4491 80.309C93.7766 81.9167 92.95 83.4511 91.9833 84.8917Z"
                fill="#006685"
              />
            </g>
            <defs>
              <clipPath id="clip0_19_2">
                <rect width="139" height="139" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      )
    }
    return null
  }

  const renderVolumeOffButton = () => {
    if (videoMuted) {
      return (
        <div
          className="absolute bottom-8 left-4 z-10"
          onClick={mute}
          onMouseEnter={handleVolumeBtnEnter}
          onMouseLeave={handleVolumeBtnLeave}
          onTouchStart={handleVolumeBtnTouchStart}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 139 139" fill="none">
            <g clipPath="url(#clip0_19_2)">
              <circle cx="69.5" cy="69.5" r="69.5" fill="#F9F5F1" />
              {volHover && (
                <path
                  d="M104.625 62.4213L97.0328 54.7932C94.9341 52.6846 91.522 52.6805 89.4183 54.7843C87.311 56.8915 87.3191 60.3104 89.4361 62.4077L97.1 70L89.4675 77.5967C87.3613 79.693 87.3573 83.101 89.4586 85.2023C91.5668 87.3105 94.9886 87.2984 97.0819 85.1754L104.625 77.525L112.222 85.1575C114.318 87.2637 117.726 87.2677 119.827 85.1665C121.936 83.0582 121.923 79.6364 119.8 77.5431L112.15 70L119.783 62.4033C121.889 60.307 121.893 56.899 119.792 54.7977C117.683 52.6895 114.261 52.7016 112.168 54.8246L104.625 62.475V62.4213Z"
                  fill="#004355"
                />
              )}
              {volHover && (
                <path
                  d="M45.5501 53.875H30C26.6863 53.875 24 56.5613 24 59.875V80.125C24 83.4387 26.6863 86.125 30 86.125H45.5501L62.25 102.786C66.0318 106.559 72.4877 103.881 72.4877 98.5385V41.4615C72.4877 36.1194 66.0318 33.4409 62.25 37.2139L45.5501 53.875Z"
                  fill="#004355"
                />
              )}
              {volHover && (
                <path
                  d="M101.625 62.4213L94.0328 54.7932C91.9341 52.6846 88.522 52.6805 86.4183 54.7843C84.311 56.8915 84.3191 60.3104 86.4361 62.4077L94.1 70L86.4675 77.5967C84.3613 79.693 84.3573 83.101 86.4586 85.2023C88.5668 87.3105 91.9886 87.2984 94.0819 85.1754L101.625 77.525L109.222 85.1575C111.318 87.2637 114.726 87.2677 116.827 85.1665C118.936 83.0582 118.923 79.6364 116.8 77.5431L109.15 70L116.783 62.4033C118.889 60.307 118.893 56.899 116.792 54.7977C114.683 52.6895 111.261 52.7016 109.168 54.8246L101.625 62.475V62.4213Z"
                  fill="#006685"
                />
              )}
              {volHover && (
                <path
                  d="M42.5501 53.875H27C23.6863 53.875 21 56.5613 21 59.875V80.125C21 83.4387 23.6863 86.125 27 86.125H42.5501L59.25 102.786C63.0318 106.559 69.4877 103.881 69.4877 98.5385V41.4615C69.4877 36.1194 63.0318 33.4409 59.25 37.2139L42.5501 53.875Z"
                  fill="#006685"
                />
              )}

              <path
                d="M101.625 62.4213L94.0328 54.7932C91.934 52.6846 88.522 52.6805 86.4182 54.7843C84.311 56.8915 84.319 60.3104 86.4361 62.4077L94.1 70L86.4675 77.5967C84.3613 79.693 84.3573 83.101 86.4585 85.2023C88.5668 87.3105 91.9886 87.2984 94.0819 85.1754L101.625 77.525L109.222 85.1575C111.318 87.2637 114.726 87.2677 116.827 85.1665C118.936 83.0582 118.923 79.6364 116.8 77.5431L109.15 70L116.783 62.4033C118.889 60.307 118.893 56.899 116.791 54.7977C114.683 52.6895 111.261 52.7016 109.168 54.8246L101.625 62.475V62.4213Z"
                fill="#006685"
              />
              <path
                d="M42.5501 53.875H27C23.6863 53.875 21 56.5613 21 59.875V80.125C21 83.4387 23.6863 86.125 27 86.125H42.5501L59.25 102.786C63.0318 106.559 69.4877 103.881 69.4877 98.5385V41.4615C69.4877 36.1194 63.0318 33.4409 59.25 37.2139L42.5501 53.875Z"
                fill="#006685"
              />
            </g>
            <defs xmlns="http://www.w3.org/2000/svg">
              <clipPath id="clip0_19_13">
                <rect width="139" height="139" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      )
    }
    return null
  }

  return (
    <div
      onClick={play}
      className={`index-2 react-player w-31 relative h-448`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {renderPlayButton()}
      {renderPauseButton()}
      {renderVolumeOnButton()}
      {renderVolumeOffButton()}
      <ReactPlayer
        url={videoSrc || ''}
        playing={playing}
        // onReady={() => setPlayerReady(true)}
        light={lightMode}
        loop={videoLoop}
        width="100%"
        height="100%"
        muted={videoMuted}
        onEnded={() => {
          if (!videoLoop) {
            setPlaying(false)
            setLightMode(
              'https://cdn.differentdog.com/images/unsafe/quality:80/width:572/format:png/plain/https://cdn.builder.io/api/v1/image/assets%2F0e0b081978d0442ca5f36e71c7712df5%2F947b85d1a8db45ac8054600fd9237707'
            )
          }
        }}
        config={{
          file: {
            attributes: {
              controls: false,
              preload: 'none'
            }
          }
        }}
        controls={false}
        playsinline={true}
      />
    </div>
  )
}

export default VideoPlayer
